module.exports = __webpack_public_path__ + "media/assets/images/logo-braintrust-white-9fdb7fc4a608ad9561aacbf840535bf7.png";